import {
	COLOR,
	SELECTED_TEXT_COLOR,
	TEXT_COLOR
} from './constants/defaultColors';
import PluginOptions from './types/PluginOptions';

const options: PluginOptions = {
	color: COLOR,
	textColor: TEXT_COLOR,
	selectedTextColor: SELECTED_TEXT_COLOR
};

export default options;
